import { Module } from 'vuex';

import { RootState, Country, Course } from 'frontend/types';

interface PremiumCancellationState {
  eligible_for_refund: boolean;
  is_monthly: boolean;
  is_renewal_subscriber: boolean;
  is_trial_subscriber: boolean;
  latest_courses: Course[];
  subscription_end_date_ts: number;
  subscription_id: number;
  subscription_rate: string;
}

const checkout: Module<PremiumCancellationState, RootState> = {
  namespaced: true,
  state: {} as PremiumCancellationState,
  mutations: {
    setValue(state: PremiumCancellationState, value: PremiumCancellationState): void {
      Object.assign(state, value);
    },
  },
};

export default checkout;
